import { ChevronRight as ChevronRightIcon } from "@mui/icons-material";
import { Card, CardHeader, Drawer } from "@mui/material";
import { useDispatch } from "react-redux";
import { closeContextMenu } from "src/redux/actions/ContextMenu.Actions";
import { IconButton } from "../IconButton/IconButton";

interface IContextMenuProps {
  id: string;
  menuHeader?: string | JSX.Element;
  children: JSX.Element;
  isOpen: boolean;
  infoSection?: JSX.Element;
  maxWidth?: number | string;
  onClose?: () => void;
  containerRef?: any;
}

const paperStyles = (): object => ({
  "& div.MuiPaper-root": { overflowY: "auto" },
  border: "none",
  boxShadow: "-2px 0px 4px -1px rgba(0,0,0,0.2), -4px 0px 5px 0px rgba(0,0,0,0.14), -1px 0px 10px 0px rgba(0,0,0,0.12)",
  "& .MuiCardHeader-action": {
    marginTop: 0,
    "& button": {
      padding: "6px",
    },
  },
  "& .MuiCardHeader-title": {
    fontSize: "1.3em !important",
  },
});

const ContextMenu = (props: IContextMenuProps): JSX.Element => {
  const { id, children, menuHeader = "", isOpen, maxWidth = 400, onClose, containerRef } = props;
  const dispatch = useDispatch();

  const closeAction = (): void => {
    if (onClose) {
      onClose();
    } else {
      dispatch(closeContextMenu(id));
    }
  };
  return (
    <Drawer
      id={`${id}-contextmenu`}
      variant="persistent"
      anchor="right"
      open={isOpen}
      hideBackdrop={true}
      container={containerRef?.current}
      PaperProps={{
        sx: paperStyles(),
      }}
      ModalProps={{ container: containerRef?.current }}
      sx={{
        "& .MuiDrawer-paper": {
          position: "absolute",
          right: 0,
          top: 0,
          height: "100%",
          width: maxWidth,
          boxShadow: 3,
          overflow: "scroll",
          display: isOpen ? "block" : "none",
        },
      }}
    >
      <Card
        sx={{
          height: "100%",
        }}
      >
        <CardHeader
          title={menuHeader}
          action={
            <IconButton id="close_context_btn" onClick={closeAction} size="large" sx={{ borderRadius: "3px" }}>
              <ChevronRightIcon />
            </IconButton>
          }
        />
        {children}
      </Card>
    </Drawer>
  );
};

export default ContextMenu;
